// src/App.js

import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Home from "./views/Home.js";
// import Archive from "./views/Archive.js";
import SinglePost from "./views/SinglePost.js";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Route component={Home} path="/" exact />
        {/* <Route component={Archive} path="/archive/" exact /> */}
        <Route component={SinglePost} path="/:slug" />
      </div>
    </BrowserRouter>
  );
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js